import { GAME_STEP } from 'constants/enums/GameStepEnum'
import { EMPTY_ARRAY_CHECK } from 'utils/ideationRegex'

export const hasUnsavedIdeation = (
	step: GAME_STEP,
	authorIdeation: string | string[]
) => {
	if (step !== GAME_STEP.Step2) return false

	const ideas = Array.isArray(authorIdeation)
		? authorIdeation
		: [authorIdeation]

	return ideas.some((idea) => idea.replace(EMPTY_ARRAY_CHECK, '').trim())
}
